import { Observable } from './observable';

export class ObservableDataSource {
  constructor({ makeCall } = {}) {
    this.makeCall = makeCall;
  }

  /**
   * When status === 'NotStarted', data === null, promise === null
   * When status === 'Loading',    data === null, promise !== null
   * When status === 'Loaded',     data !== null, promise === null
   *
   * @private
   */
  model = {
    status: 'NotStarted', // or 'Loading', 'Loaded'
    data: null,
    promise: null,
  }

  /**
   * the real called function when call `load` method.
   *
   * Attention: Component should not use or change this directly!
   *
   * @public
   */
  makeCall = undefined

  /**
   * @private
   */
  observers = []

  /**
   * @private
   */
  observable = new Observable((observer) => {
    this.observers.push(observer);

    const { model } = this;
    switch (model.status) {
      case 'Loaded':
        observer.next(model.data);
        break;
      case 'Loading':
        model.promise.then((data) => {
          observer.next(data);
        });
        break;
      case 'NotStarted':
      default:
        this.load().then((data) => {
          observer.next(data);
        });
        break;
    }

    // Leverage arrow function to auto bind `this`
    const unsubscribe = () => {
      this.observers = this.observers.filter(s => s !== observer);
    };

    return unsubscribe;
  });

  /**
   * subscribe to the data souce
   *
   * @public
   * @param {Function | { next: Function }} observer observer.
   * @returns {Function} unsubscribe function
   */
  subscribe(observer) {
    return this.observable.subscribe(observer);
  }


  /**
   * @private
   * @returns {any} the promise of `this.model`
   */
  load() {
    const { model } = this;

    model.status = 'Loading';
    model.data = null;
    model.promise = this.makeCall();

    model.promise.then((data) => {
      // once loaded, cache data
      model.status = 'Loaded';
      model.data = data;
      model.promise = null;
    });

    return model.promise;
  }

  /**
   * make all subscriptions update the data through internal call
   *
   * @public
   * @returns {Promise<any>} the promise of observers update.
   */
  refresh = () => {
    const { model } = this;

    if (model.status === 'NotStarted') {
      // No need to refresh, ignore.
      return Promise.resolve();
    }

    if (model.status === 'Loading') {
      // Ideally, should cancel the previous request. Pseudocode:
      // model.promise.cancel();
    }

    return this.load().then((data) => {
      this.observers.forEach((observer) => {
        observer.next(data);
      });
    });
  }
}
